module.exports = __webpack_public_path__ + "static/media/Tynax-buyers-300.85162e68.jpg";